import { IconWrapper } from '../runtime';
export default IconWrapper('wpp-format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 3.75C0 1.67893 1.67893 0 3.75 0H20.25C22.3211 0 24 1.67893 24 3.75V20.25C24 22.3211 22.3211 24 20.25 24H3.75C1.67893 24 0 22.3211 0 20.25V3.75Z",
      "fill": 'url(#' + props.id + 'd2c0b93f' + ')'
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M14.625 7.5H7.125C6.71079 7.5 6.375 7.16421 6.375 6.75V6C6.375 5.58579 6.71079 5.25 7.125 5.25H14.625C17.1103 5.25 19.125 7.26472 19.125 9.75C19.125 12.2353 17.1103 14.25 14.625 14.25H8.625V18.75C8.625 19.1642 8.28921 19.5 7.875 19.5H7.125C6.71079 19.5 6.375 19.1642 6.375 18.75V13.125C6.375 12.5037 6.87868 12 7.5 12H14.625C15.8676 12 16.875 10.9926 16.875 9.75C16.875 8.50736 15.8676 7.5 14.625 7.5Z",
      "fill": "white"
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": props.id + 'd2c0b93f',
      "x1": "0",
      "y1": "0",
      "x2": "24",
      "y2": "24",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#FF9012"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#EC6810"
    }
  })])])]);
});